import { RESET_STATE } from 'store/global/actions';

import { CONCESSION_ACTION_TYPE } from '../actions';

const initialState = {
  list: { data: [], isLoading: false, hasError: false },
  decision: { isSaving: false, errorMessage: null },
};

const upsertConcession = (rows, row) => {
  const exists = rows.some(item => item.concessionRequestId === row.concessionRequestId);

  return exists
    ? rows.map(item => (item.concessionRequestId === row.concessionRequestId ? row : item))
    : [row, ...rows];
};

const concessionReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case CONCESSION_ACTION_TYPE.SET_LOADING:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: payload,
          hasError: payload ? false : state.list.hasError,
        },
      };

    case CONCESSION_ACTION_TYPE.SET_ERROR:
      return { ...state, list: { ...state.list, isLoading: false, hasError: true } };

    case CONCESSION_ACTION_TYPE.GET_CONCESSIONS:
      return { ...state, list: { data: payload ?? [], isLoading: false, hasError: false } };

    case CONCESSION_ACTION_TYPE.SET_DECISION_SAVING:
      return { ...state, decision: { isSaving: payload, errorMessage: null } };

    case CONCESSION_ACTION_TYPE.SET_DECISION_ERROR:
      return { ...state, decision: { isSaving: false, errorMessage: payload ?? null } };

    case CONCESSION_ACTION_TYPE.CLEAR_DECISION_ERROR:
      return { ...state, decision: { ...state.decision, errorMessage: null } };

    // A decided concession stays in the list (in place) — Guardrails' consumed-budget computation needs
    // Approved/AutoApproved rows to remain visible, unlike the maker-checker queue which drops resolved
    // rows entirely.
    case CONCESSION_ACTION_TYPE.RESOLVE_CONCESSION:
      return {
        ...state,
        list: { ...state.list, data: upsertConcession(state.list.data, payload) },
        decision: { isSaving: false, errorMessage: null },
      };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default concessionReducer;
